import React, { useEffect } from "react";
import CardTileA from "../../Common/CardTileA";
import { useSchoolTransactions } from "../../../DataStore/FeesTransactionContext";
import functions from "../../../util/functions";
import { numberFormat } from "../../../util/araknerdlib";

const BillingMetricCards = ({currency}) =>{
    
    const {
            billedRatio,
            paidSum,
            billedSum,
            getBilledSum,
            getPaidSum,
            grossBalanceRatio,
            getBilledRatio,
            getGrossBalanceRatio,
        } = useSchoolTransactions();
    
        useEffect(()=>{
            getBilledSum();
            getPaidSum();
            getBilledRatio();
            getGrossBalanceRatio();
        }, []);

    return(

        <div className="row mb-4">
            <div className="col-md-3">
                <CardTileA 
                    title="Total Billed" 
                    value={billedSum ? numberFormat(billedSum) : '--'}
                    cardIcon="fa fa-bookmark"
                    cardIconClass="text-primary"
                    preText={`This term (${currency || ''})`}
                    borderColorClass={'primary'}
                    />
            </div>
            <div className="col-md-3">
                <CardTileA 
                    title="Total Paid" 
                    value={paidSum ? numberFormat(paidSum) : '--'}
                    cardIcon="fa fa-check"
                    cardIconClass="text-success"
                    preText={`This term (${currency || ''})`}
                    borderColorClass={'success'}

                    />
            </div>

            <div className="col-md-3">
              <CardTileA 
                title="Billed Students" 
                value={`${billedRatio?.percent || '0.0'}%`} 
                cardIcon="fa fa-users"
                cardIconClass="text-primary"
                preText={`${billedRatio?.billed || '--'} of ${billedRatio?.total || '--'}`} 
                borderColorClass={'primary'}
                progressColor={'#3e69d8'}
                progressValue={billedRatio?.billed || '0'}
                />
                
            </div>

            <div className="col-md-3">
                <CardTileA 
                    title="NUMBER OF DEFAULTERS" 
                    value={functions.isObject(grossBalanceRatio) ? grossBalanceRatio.current_defaulters : '...'} 
                    cardIcon="fa fa-user"
                    cardIconClass="text-danger"
                    preText={` Worth UGX ${functions.isObject(grossBalanceRatio) ? functions.numberFormat(grossBalanceRatio.current_balance) : '...'}`}
                    borderColorClass={'danger'}
                    />
                
            </div>
       
        </div>


    )
}

export default BillingMetricCards;